import { render, staticRenderFns } from "./VlResultOfExaminationFilter.vue?vue&type=template&id=55e6a2f3&scoped=true&"
import script from "./VlResultOfExaminationFilter.vue?vue&type=script&lang=js&"
export * from "./VlResultOfExaminationFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6a2f3",
  null
  
)

export default component.exports